import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const useDevToolsDetection = () => {
  const navigate = useNavigate();
  const devToolsOpenRef = useRef(false);
  const reloadedRef = useRef(false);

  const threshold = 160;

  const isDevToolsOpen = () => {
    return (
      window.outerHeight - window.innerHeight > threshold ||
      window.outerWidth - window.innerWidth > threshold
    );
  };

  const checkDevTools = () => {
    const devToolsOpen = isDevToolsOpen();

    localStorage.setItem("devtools_open", devToolsOpen.toString());

    // ✅ Always redirect if DevTools are open
    if (devToolsOpen) {
      devToolsOpenRef.current = true;
      navigate("/auth-error");
    }

    // ✅ If DevTools were previously open and now closed, reload once
    if (!devToolsOpen && devToolsOpenRef.current && !reloadedRef.current) {
      devToolsOpenRef.current = false;
      reloadedRef.current = true;
      window.location.href = "/";
    }
  };

  useEffect(() => {
    // ✅ Init devToolsOpenRef on first load
    devToolsOpenRef.current = isDevToolsOpen();

    checkDevTools(); // Run immediately
    const interval = setInterval(checkDevTools, 500);
    return () => clearInterval(interval);
  }, [navigate]);
};

export default useDevToolsDetection;
